<div class="icon">
  <ng-content select=".icon"></ng-content>
</div>

<div class="data">
  <ng-content select=".data"></ng-content>
</div>
